import api from "../../api.js";

export default class PageAdminOps
{
    constructor(targetElement)
    {
        api.get("ops/stats", (res) =>
        {
            let html = "<table class=\"admintable\">";
            html += "<tr>";
            html += "<th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>";
            html += "<th>&nbsp;&nbsp;</th>";
            html += "<th>&nbsp;&nbsp;</th>";
            html += "<th>&nbsp;&nbsp;</th>";
            html += "<th>name&nbsp;&nbsp;</th>";
            html += "<th>summary&nbsp;&nbsp;</th>";
            html += "<th>op example&nbsp;&nbsp;</th>";
            html += "<th>testcase&nbsp;&nbsp;</th>";
            html += "<th>layout&nbsp;&nbsp;</th>";
            html += "<th>hasOpId&nbsp;&nbsp;</th>";

            html += "<th>code sucks&nbsp;&nbsp;</th>";
            html += "<th>lines&nbsp;&nbsp;</th>";
            html += "<th>libs&nbsp;&nbsp;</th>";
            html += "</tr>";

            for (let i in res.active)
            {
                html += this.getAdminOpRow(res.active[i], false);
            }

            for (let i in res.deprecated)
            {
                html += this.getAdminOpRow(res.deprecated[i], true);
            }

            html += "</table>";
            document.getElementById("stats").innerHTML = html;
        });
    }

    getAdminOpRow(op, deprecated)
    {
        let data = op;
        data.opGood = (op.hasDoc && op.hasExample && op.hasTest && !op.containsThis && !op.containsSelf && !op.containsApply && !op.containsConsole && !op.containsVal) == true;

        let points = 0;
        if (op.hasSummary)points += 3;
        if (op.hasDoc)points += 5;
        if (op.hasExample)points += 5;
        if (op.hasOpExample)points += 5;
        if (op.hasTest)points += 5;
        if (op.hasLayout)points += 3;
        if (!op.containsThis)points++;
        if (!op.containsSelf)points++;
        if (!op.containsApply)points++;
        if (!op.containsConsole)points++;
        if (!op.containsVal)points++;

        data.point = points;

        let g = points / 26 / 1.3;
        let r = 1.0 - points / 19;

        data.color = "background-color:rgb(" + (Math.round(r * 255)) + "," + (Math.round(g * 255)) + ",20);";
        let style = "";

        if (deprecated)style += "opacity:0.3;";
        if (op.invalid)style += "background-color:var(--warning);";

        data.style = style;

        data.warnings = "";
        for (let j in op.srcWarnings)
        {
            data.warnings += "[" + op.srcWarnings[j].id + "] ";
        }

        data.invalid = "";
        if (op.invalid) data.invalid += "[invalid]";

        data.oplibs = "";
        if (op.libs) data.oplibs = op.libs.join(" ");

        return web.getHandleBarHtml("admin_op", data);
    }
}
